const createImage = (srcPath: string, altText: string) => ({
  src: `/${srcPath}`,
  alt: altText,
})

const imagesPath = `assets/images`

// for image purpose
const responovaIcon = createImage(`${imagesPath}/responova-icon.png`, `responova-icon`)
const populixLogo = createImage(`${imagesPath}/populix_logo.png`, `populix_logo`)
const authBanner = createImage(`${imagesPath}/auth_banner.webp`, `auth_banner`)
const responovaLogo = createImage(`${imagesPath}/responova_logo.png`, `responova_logo`)
const popcornHappy = createImage(`${imagesPath}/popcorn_happy.png`, `popcorn_happy`)
const popcornPanic = createImage(`${imagesPath}/popcorn_panic.png`, `popcorn_panic`)
const gadgetReward = createImage(`${imagesPath}/gadget_reward.png`, `gadget_reward`)
const playStore = createImage(`${imagesPath}/play_store.png`, `play_store`)
const appStore = createImage(`${imagesPath}/app_store.png`, `app_store`)
const loadingState = createImage(`${imagesPath}/loading_state.png`, `loading_state`)
const handRaise = createImage(`${imagesPath}/hand_raise.png`, `hand_rise`)
const brokenLink = createImage(`${imagesPath}/broken_link.png`, `broken_link`)
const stressCalendar = createImage(`${imagesPath}/stress_calendar.png`, `stress_calendar`)
const alert = createImage(`${imagesPath}/alert.png`, `alert`)
const rejected = createImage(`${imagesPath}/rejected.png`, `rejected`)
const approved = createImage(`${imagesPath}/approved.png`, `approved`)
const ratingLike = createImage(`${imagesPath}/rating_like.png`, `rating_like`)
const surveyTaken = createImage(`${imagesPath}/survey-taken.png`, `survey taken`)
const surveyInReview = createImage(`${imagesPath}/in_review.png`, `survey in review`)
const surveyIllustration = createImage(
  `${imagesPath}/survey_illustration.png`,
  'survey illustration',
)
const rewardIllustration = createImage(
  `${imagesPath}/reward_illustration.png`,
  'reward illustration',
)
const privacyIllustration = createImage(
  `${imagesPath}/privacy_illustration.png`,
  'privacy illustration',
)
const sliderBackground = createImage(`${imagesPath}/slider_background.png`, 'slider background')

const popUpBanner = createImage(`${imagesPath}/popup_banner.png`, 'popup banner')
const notePencil = createImage(`${imagesPath}/note_pencil.png`, 'note pencil')
const rocketFixing = createImage(`${imagesPath}/rocket_fixing.png`, 'rocket fixing')
const specialTag = createImage(`${imagesPath}/special_tag.png`, 'special_tag')
const handMoney = createImage(`${imagesPath}/hand_money.png`, 'hand money')
const freeWithdrawalBanner = createImage(
  `${imagesPath}/free_withdrawal_banner.png`,
  'free withdrawal banner',
)
const pointIcon = createImage(`${imagesPath}/point.png`, `point`)
const rupiahIcon = createImage(`${imagesPath}/rupiah.png`, `rupiah`)
const emptyStateIcon = createImage(`${imagesPath}/empty_state.png`, `empty_state`)
const accountRegisteredIcon = createImage(
  `${imagesPath}/account_registered.png`,
  `account_registered`,
)
const markEmailReadIcon = createImage(`${imagesPath}/mark_email_read.png`, `mark_email_read`)
const checklistDocument = createImage(`${imagesPath}/checklist-document.png`, 'checklist document')
const dollarCircle = createImage(`${imagesPath}/dollar-circle.png`, 'dollar circle')
const customerCheck = createImage(`${imagesPath}/customer-check.png`, 'customer checklist')
const unlockIcon = createImage(`${imagesPath}/unlock.png`, 'unlock')

const refund = createImage(`${imagesPath}/refund.png`, 'refund')

const brokenCreditCard = createImage(`${imagesPath}/broken-credit-card.png`, 'broken-credit-card')

export {
  rejected,
  approved,
  alert,
  notePencil,
  rocketFixing,
  specialTag,
  handMoney,
  responovaIcon,
  freeWithdrawalBanner,
  surveyIllustration,
  rewardIllustration,
  privacyIllustration,
  sliderBackground,
  customerCheck,
  dollarCircle,
  checklistDocument,
  populixLogo,
  authBanner,
  responovaLogo,
  popcornHappy,
  popcornPanic,
  gadgetReward,
  playStore,
  appStore,
  loadingState,
  handRaise,
  pointIcon,
  rupiahIcon,
  emptyStateIcon,
  accountRegisteredIcon,
  markEmailReadIcon,
  brokenLink,
  stressCalendar,
  ratingLike,
  popUpBanner,
  unlockIcon,
  refund,
  brokenCreditCard,
  surveyTaken,
  surveyInReview,
}
